module.exports = __webpack_public_path__ + "media/flags/cn-7bd73c73.svg";